import { useDispatch, useSelector } from 'react-redux';
import {
  type ThunkAction,
  type UnknownAction,
  configureStore,
} from '@reduxjs/toolkit';
import { baseApi } from 'api/baseApi';
import { rememberEnhancer, rememberReducer } from 'redux-remember';
import { listenerMiddleware } from 'slices/listenerMiddleware';
import rootReducer from '.';

const persistedSlices = [
  'persistedFilters',
  'persistedColumns',
  'aopUserConfig',
];

const store = configureStore({
  reducer: rememberReducer(rootReducer),
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .prepend(listenerMiddleware.middleware)
      .concat(baseApi.middleware),
  enhancers: (getDefaultEnhancers) =>
    getDefaultEnhancers().concat(
      rememberEnhancer(window.localStorage, persistedSlices)
    ),
});

export type TAppDispatch = typeof store.dispatch;
export type TAppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  TRootState,
  unknown,
  UnknownAction
>;
export type TRootState = ReturnType<typeof rootReducer>;

export const useAppDispatch = useDispatch.withTypes<TAppDispatch>();
export const useAppSelector = useSelector.withTypes<TRootState>();

export default store;
